import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, FlexSpan, H5, Icon, Table, TextInput } from "../../../ui";
import { InfoIcon } from "../../InfoIcon";
import { TableHeaderContainer, TableStickyBodyCell } from "../../ParamsTable/styled";
import { formatNumber } from "../../../utils";
export const Segment = ({ data, values, onUpdateValues }) => {
    return (_jsxs(Flex, { column: true, children: [_jsx(FlexSpan, { children: _jsx(Flex, { column: true, p: "1rem", mb: "1.5rem", border: "1px solid #E3E3E3", borderRadius: "0.75rem", children: _jsx(FlexSpan, { children: _jsxs(Flex, { alignItems: "center", children: [_jsx(FlexSpan, { display: "flex", mr: "0.75rem", children: _jsx(Icon, { icon: "wallet", size: 20, color: "#9D87F1" }) }), _jsx(FlexSpan, { flexGrow: 1, children: _jsxs(Flex, { alignItems: "center", children: [_jsx(FlexSpan, { children: _jsx(H5, { children: "\u0421\u0440\u0435\u0434\u043D\u0438\u0435 \u0437\u0430\u0442\u0440\u0430\u0442\u044B \u043D\u0430 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0446\u0438\u0438 / \u0443\u0441\u043B\u0443\u0433" }) }), _jsx(FlexSpan, { display: "flex", children: _jsx(InfoIcon, { content: "Расчетная средняя сумма за год, которую тратят клиенты на товары/услуги данного бизнеса. " +
                                                        "Величина затрат зависит от среднего чека. Изменить значение среднего чека можно в блоке «Доходы»" }) })] }) }), _jsx(FlexSpan, { style: { whiteSpace: "nowrap" }, ml: "1.5rem", children: _jsxs(H5, { children: [formatNumber((data?.parameters?.avg_check ?? 0) * (data?.info?.frequency ?? 0)), " \u0440\u0443\u0431. \u0432 \u0433\u043E\u0434"] }) })] }) }) }) }), _jsx(FlexSpan, { children: _jsx(Table, { cellGap: 0, columns: [
                        {
                            id: "name",
                            title: "Наименование",
                            width: "calc(30% - 0.25rem)",
                            renderHead: column => (_jsx(TableHeaderContainer, { width: "100%", mb: "0.125rem", children: _jsx(H5, { children: column.title }) })),
                            renderBody: (row, rowId) => {
                                return (_jsx(TableStickyBodyCell, { firstRow: rowId === 0, lastRow: rowId === 3, firstCol: true, withBackground: true, children: _jsxs(Flex, { justifyContent: "space-between", children: [_jsx(FlexSpan, { children: row.data.name }), _jsx(FlexSpan, { children: _jsx(InfoIcon, { content: row.data.description }) })] }) }));
                            },
                        },
                        {
                            id: "value",
                            title: "Описание",
                            width: "calc(70% - 0.25rem)",
                            renderHead: column => (_jsx(TableHeaderContainer, { width: "100% + 0.125rem", mb: "0.125rem", children: _jsx(H5, { children: column.title }) })),
                            renderBody: (row, rowId) => {
                                return (_jsx(TableStickyBodyCell, { firstRow: rowId === 0, lastRow: rowId === 3, lastCol: true, isEditing: true, children: _jsx(TextInput, { style: { border: "none" }, inputStyle: { fontSize: "0.75rem", padding: "0 0.75rem" }, height: "2.5rem", maxLength: row.data.maxLength, value: values[row.id] ?? "", onChange: value => onUpdateValues?.({
                                            [row.id]: value || "",
                                        }) }) }));
                            },
                        },
                    ], rows: [
                        {
                            id: "segment_portrait",
                            data: {
                                name: "Социальный портрет покупателя",
                                description: "Опишите основных потребителей ваших товаров/услуг",
                                maxLength: 180,
                            },
                        },
                        {
                            id: "segment_target",
                            data: {
                                name: "Цель посещения",
                                description: "Укажите основную цель посещения вашего бизнеса",
                                maxLength: 150,
                            },
                        },
                        {
                            id: "segment_time",
                            data: {
                                name: "Время посещения",
                                description: "Укажите типичное (пиковое) время посещения вашего бизнеса",
                                maxLength: 60,
                            },
                        },
                        {
                            id: "segment_profit",
                            data: {
                                name: "Основная выгода для покупателя",
                                description: "Укажите, какую пользу получат клиенты вашего бизнеса",
                                maxLength: 60,
                            },
                        },
                    ] }) })] }));
};
